import React, { useState, useEffect } from 'react';

export default function LocationModal({ open, onClose, node, onSave }) {
  const [formData, setFormData] = useState({
    bodyText: '',
    delay: 0
  });

  useEffect(() => {
    if (open && node) {
      setFormData({
        bodyText: node.data.bodyText || '',
        delay: node.data.delay || 0
      });
    }
  }, [open, node]);

  const handleSave = () => {
    if (onSave) {
      onSave(node.id, formData);
    }
    onClose();
  };

  if (!open) return null;

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  };

  const contentStyle = {
    background: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    minWidth: '600px',
    maxWidth: '700px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
  };

  const headerStyle = {
    background: '#1e3a8a',
    color: '#ffffff',
    padding: '16px 24px',
    margin: '-24px -24px 24px -24px',
    borderRadius: '8px 8px 0 0',
    fontWeight: 'bold',
    fontSize: '18px',
    textAlign: 'center'
  };

  const textareaStyle = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '12px',
    fontSize: '14px',
    marginBottom: '12px',
    outline: 'none',
    minHeight: '120px',
    resize: 'vertical',
    fontFamily: 'inherit',
    position: 'relative'
  };

  const buttonStyle = {
    background: '#007bff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    marginRight: '8px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px'
  };

  const secondaryButtonStyle = {
    background: '#6c757d',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px'
  };

  const dividerStyle = {
    border: 'none',
    borderTop: '2px dashed #d1d5db',
    margin: '24px 0'
  };

  const emojiButtonStyle = {
    position: 'absolute',
    top: '8px',
    right: '8px',
    background: 'none',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    color: '#6c757d',
    padding: '4px',
    borderRadius: '4px',
    transition: 'color 0.2s ease'
  };

  const grammarButtonStyle = {
    position: 'absolute',
    bottom: '8px',
    right: '8px',
    background: '#28a745',
    color: '#ffffff',
    border: 'none',
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 'bold'
  };

  const textareaContainerStyle = {
    position: 'relative'
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={contentStyle} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={headerStyle}>
          Configure Location Template
        </div>

        {/* Body Text Input */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Please provide body text*
          </label>
          <div style={textareaContainerStyle}>
            <textarea
              value={formData.bodyText}
              onChange={e => setFormData(prev => ({ ...prev, bodyText: e.target.value }))}
              placeholder="Enter your location message here..."
              style={textareaStyle}
            />
            {/* Emoji Picker Button */}
            <button 
              style={emojiButtonStyle}
              title="Add emoji"
              onMouseOver={e => e.currentTarget.style.color = '#007bff'}
              onMouseOut={e => e.currentTarget.style.color = '#6c757d'}
            >
              😊
            </button>
            {/* Grammar Assistant Button */}
            <button 
              style={grammarButtonStyle}
              title="Grammar assistant"
            >
              G
            </button>
          </div>
        </div>

        {/* Delay Slider */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Delay in reply - {formData.delay} sec
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <input
              type="range"
              min="0"
              max="30"
              value={formData.delay}
              onChange={e => setFormData(prev => ({ ...prev, delay: parseInt(e.target.value) }))}
              style={{ 
                flex: 1,
                height: '6px',
                borderRadius: '3px',
                background: '#d1d5db',
                outline: 'none',
                WebkitAppearance: 'none',
                appearance: 'none'
              }}
            />
            <span style={{ fontSize: '14px', color: '#6c757d', minWidth: '50px' }}>
              {formData.delay} sec
            </span>
          </div>
        </div>

        {/* Divider */}
        <hr style={dividerStyle} />

        {/* Action Buttons */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button onClick={handleSave} style={buttonStyle}>
            💾 Save
          </button>
          <button onClick={onClose} style={secondaryButtonStyle}>
            ✕ Close
          </button>
        </div>
      </div>
    </div>
  );
} 